// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mrtn-header--center .mrtn-rating-breakdown{max-width:520px;width:100%}", ""]);
// Exports
module.exports = exports;
